import { LoadingButton } from '@mui/lab';
import { Button, Grid, TextField } from '@mui/material';
import { ResponsiveDialog, ResponsiveDialogActions, ResponsiveDialogContent, ResponsiveDialogTitle } from 'components';
import { LaborClassificationDto, laborClassificationValidationSchema } from 'dtos';
import { Form, Formik } from 'formik';

interface AddEditLaborClassDialogProps {
  isLoading?: boolean;
  laborClassification: LaborClassificationDto;
  onClose: () => void;
  onSave: (values: LaborClassificationDto) => void;
  open: boolean;
}

export default function AddEditLaborClassDialog({
  isLoading,
  laborClassification,
  onClose,
  onSave,
  open
}: AddEditLaborClassDialogProps) {
  return (
    <ResponsiveDialog open={open}>
      <Formik
        enableReinitialize
        initialValues={laborClassification}
        onSubmit={values => {
          onSave(values);
        }}
        validateOnBlur
        validateOnChange
        validationSchema={laborClassificationValidationSchema}
      >
        {({ errors, handleBlur, handleChange, touched, values }) => (
          <Form>
            <ResponsiveDialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ResponsiveDialogTitle>{laborClassification.id ? 'Edit' : 'Add'} Labor Classification</ResponsiveDialogTitle>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    disabled={isLoading}
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label='Name'
                    name='name'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    size='small'
                    value={values.name}
                  />
                </Grid>
              </Grid>
            </ResponsiveDialogContent>

            <ResponsiveDialogActions>
              <Button color='error' disabled={isLoading} onClick={onClose}>
                CANCEL
              </Button>

              <LoadingButton color='primary' loading={isLoading} type='submit'>
                SAVE
              </LoadingButton>
            </ResponsiveDialogActions>
          </Form>
        )}
      </Formik>
    </ResponsiveDialog>
  );
}
